import React, { useEffect, useState } from "react";
import moment from "moment";
import { Typography } from "@mui/material";
import NumberFormat from "react-number-format";

import { withRouter } from "react-router";
import { compose } from "underscore";
import { connect } from "react-redux";

import { CustomButton, DefaultLoader, ButtonWrapper } from "../../components";
import { images } from "../../constants";
import { Container, Row } from "./styles";
import { getTransactionHistory } from "../redux/action";

const WithdrawalPending = props => {
  const {
    history,
    lastTransaction,
    loadingLastTransaction,
    getTransactionHistory,
  } = props;

  const [withdrawalData] = useState({
    date: moment()
      .utcOffset("+0800")
      .format("DD MMM YYYY hh:mm:ss")
      .slice(0, 11),
    time: moment()
      .utcOffset("+0800")
      .format("DD MMM YYYY hh:mm:ss A")
      .slice(12, 24),
    refNo: lastTransaction.trxRefNo,
    transactionId: lastTransaction.transactionHostRefNo,
    // backend cannot guarantee that last transaction data is correct, in particular: amount and fee field
    // so in order for data to synchrone with user latest cashout
    // we have to reuse data that user submit during cashout process
    amount: history.location?.state?.amount,
    fee: history.location?.state?.fee,
  });

  useEffect(() => {
    getTransactionHistory({
      page: 1,
      size: 1,
      showAll: true,
    });
  }, []);

  if (loadingLastTransaction) return <DefaultLoader />;

  return (
    <Container>
      {/* logo */}
      <div style={{ marginTop: "16px", marginLeft: "16px" }}>
        <img src={images.principalLogo} alt="principal-logo" />
      </div>

      {/* Submitted text */}
      <div style={{ margin: "24px 16px" }}>
        <Typography
          color="textPrimary"
          sx={{
            fontSize: "20px",
            fontWeight: "700",
          }}
        >
          Cash Out is in progress...
        </Typography>
        <Typography
          color="textPrimary"
          sx={{
            padding: "16px 0 24px",
            borderBottom: "1px solid #9d9ea4",
          }}
        >
          Your Cash Out request is still pending. Please check the transaction
          history for its status in 15 to 30 minutes. For assistance, please
          contact our{" "}
          <span
            style={{
              color: "#0076cf",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {}}
          >
            customer support
          </span>
          .
        </Typography>
      </div>

      {/* Submitted details */}
      <div style={{ margin: "0 16px" }}>
        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Cash Out Amount</Typography>
          <Typography color="textPrimary">
            RM{" "}
            <NumberFormat
              value={withdrawalData.amount}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Bank Transaction Fee</Typography>
          <Typography color="textPrimary">
            RM{" "}
            <NumberFormat
              value={withdrawalData.fee}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Cash Out Via</Typography>
          <Typography color="textPrimary">FPX Online Banking</Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Date</Typography>
          <Typography color="textPrimary">{withdrawalData.date}</Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Time</Typography>
          <Typography color="textPrimary">{withdrawalData.time}</Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Reference No</Typography>
          <Typography color="textPrimary" style={{ textAlign: "right" }}>
            {withdrawalData.refNo}
          </Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Transaction ID</Typography>
          <Typography color="textPrimary">
            {withdrawalData.transactionId}
          </Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginTop: "16px" }}>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "700",
              lineHeight: 1.4,
              color: "#084c95",
            }}
          >
            Total:
          </Typography>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "700",
              lineHeight: 1.4,
              color: "#084c95",
            }}
          >
            RM{" "}
            <NumberFormat
              value={withdrawalData.amount - withdrawalData.fee}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </Typography>
        </Row>
      </div>

      <ButtonWrapper
        style={{
          backgroundColor: "#fff",
        }}
      >
        <CustomButton
          text="Done"
          variant="contained"
          color="#fff"
          backgroundColor="#1278cc"
          onClick={() => history.push("/dashboard")}
        />
      </ButtonWrapper>
    </Container>
  );
};

const withConnect = connect(
  state => ({
    loadingLastTransaction: state.goal.loadingTransactionHistory,
    lastTransaction: state.goal.transactionHistory.data[0],
  }),
  { getTransactionHistory }
);

export default compose(
  withRouter,
  withConnect
)(WithdrawalPending);
